export type LatLng = {
  lat: number;
  lng: number;
};

export const toInputDate = (date: Date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 10);
};

export const toInputTime = (date: Date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(11, 16);
};

export const toInputDateTime = (date: Date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
};

export const composeLocalDateTime = (dateValue: string, timeValue: string) => {
  if (!dateValue || !timeValue) return null;
  const composed = new Date(`${dateValue}T${timeValue}`);
  if (Number.isNaN(composed.getTime())) return null;
  return composed;
};

export const parseLocation = (value?: string | null): LatLng | null => {
  if (!value) return null;
  const [lat, lng] = value.split(",").map((item) => Number(item.trim()));
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return { lat, lng };
};

export const formatCoordinate = (value: number) => value.toFixed(6);

const toCourseAbbreviation = (name?: string | null) => {
  if (!name) return "BUOI";
  const cleaned = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, " ")
    .trim();
  if (!cleaned) return "BUOI";

  const words = cleaned.split(/\s+/).filter(Boolean);
  if (words.length === 1) {
    return words[0].slice(0, 4).toUpperCase();
  }
  return words
    .slice(0, 4)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

const generateRandom6Digits = () =>
  String(Math.floor(100000 + Math.random() * 900000));

export const buildSessionTitle = (className?: string | null) =>
  `${toCourseAbbreviation(className)}-${generateRandom6Digits()}`;

// `t` translates key-style messages thrown by services (e.g. vietmapService); without it,
// callers receive the raw key and must translate it themselves.
export const toFriendlyError = (
  error: unknown,
  fallback: string,
  t: (key: string) => string = (key) => key
) => {
  if (error instanceof Error) {
    if (
      error.message === "Load failed" ||
      error.message.includes("Failed to fetch")
    ) {
      return t("venue.serverUnreachable");
    }
    return t(error.message);
  }
  return fallback;
};
